<template>
    <div class="content" v-loading='loading'>
        <el-form label-postion="left" label-width="80px">
            <el-form-item label="设备名称">
              <span>{{name}}-{{ms}}</span>
            </el-form-item>
            <el-form-item label="当前策略">
              <span>{{nowstg}}</span>
            </el-form-item>
            <el-form-item label="修改策略">
              <el-select v-model="id" placeholder="请选择">
                <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="控制模式">
              <el-switch v-model="ms" active-text="自动" inactive-text="手动" :active-value="0" :inactive-value="1" inactive-color="gray" @change="manualChange = true"></el-switch>
            </el-form-item>
            <el-form-item label="亮度设置" v-if="ms">
              <el-slider v-model="light" :min="0" :max="10" show-input @change="manualChange = true"></el-slider>
            </el-form-item>
            <el-button type="primary" @click="parseDeviceInfo">保存</el-button>
            <el-button @click="cancel">取消</el-button>
        </el-form>
    </div>
</template>
<script>
import lightListApi from '@/api/light/lightList'
import strategyApi from '@/api/light/strategy'
export default {
  data () {
    return {
	    loading:false,
      manualChange: false,
      name: this.$route.query.name,
	    light: this.$route.query.light,
      nowstgid: this.$route.query.stg_id,
      nowstg:  this.$route.query.stg_name,
      id: this.$route.query.stg_id,
      ms: this.$route.query.ms,
      options:[],
      updateInfo: {
        lamp_id: this.$route.query.id,
        light: 0,
        stg_id: 0,
        ms: 0
      }
    }
  },
  methods: {
    getStyList () {
	    strategyApi.strategyList({page: 1,pageSize: 200}).then(res => {
        if (res.data.code === 1000) {
          this.options = res.data.data.list
        }
      })
    },
    parseDeviceInfo () {
      this.updateInfo.light = this.light
      this.updateInfo.ms = this.ms
      if (this.updateInfo.ms === 0||this.updateInfo.ms === '0') { //0自动
        if (this.id === 0 && this.nowstgid === 0) {
          this.$message.error('请选择策略')
        } else if (this.id === 0 && this.nowstgid !== 0) {
          this.updateInfo.stg_id = this.nowstgid
          this.updateLightStrategy()
        } else {
          this.updateInfo.stg_id = this.id
          this.updateLightStrategy()
        }
      } else { // 1手动
        this.updateInfo.stg_id = this.nowstgid
        this.updateLightStrategy()
      }
    },
    updateLightStrategy () {
      lightListApi.lightStrategysSave(this.updateInfo.lamp_id,this.updateInfo).then(res => {
        if (res.data.code === 1000) {
          this.$message.success('更改成功！')
          if(this.updateInfo.ms===1){ // 1手动
            this.lightContorl()
          }
        }
      })
    },
    lightContorl () {
      let sendData = {
        light: this.updateInfo.light,
        light2: this.updateInfo.light
      }
      lightListApi.lightControl(this.updateInfo.lamp_id,sendData).then(res => {
        if (res.data.code === 1000) {
          this.$message.success('下发成功')
        }
      })
    },
    cancel () {
      this.$router.back()
    }
  },
  mounted () {
    this.getStyList()
  }
}
</script>
<style scoped>
.el-form {
  width:100%;
}
</style>
